const ADMIN_ROLE = 'admin';
const USER_ROLE = 'user';
const SUPERVISOR_ROLE = 'supervisor';

export default { ADMIN_ROLE, USER_ROLE, SUPERVISOR_ROLE };
